import {db} from "../Database/handwaiDB.js";


export function setLVDocumentDB(lvDocument) {
	
	(async () => {
		try {
			removeLVDocumentDB()
			await db.lvDocument.put({
				data: lvDocument
			});
		} catch (error) {
			console.log(error);
		}
	})();
	
}

export async function getLVDocumentDB() {
	
	let data;
	
	try {
		
		const result = await db.lvDocument.toArray(
			function (lvDocument) {
				data = JSON.stringify(lvDocument)
				return data;
			}
		);
		
		return JSON.parse(result.toString())
		
	} catch (error) {
		console.log(error);
	}
}

export function removeLVDocumentDB() {
	
	(async () => {
		try {
			await db.lvDocument.clear();
		} catch (error) {
			console.log(error);
		}
	})();
	
}